export type SocialIcon = {
  url: string;
  icon: string;
};

export const socialIcons: Record<string, SocialIcon> = {
  facebook: {
    url: 'https://www.facebook.com/teambravado/',
    icon: require('./images/facebook.svg'),
  },
  linkedin: {
    url: 'https://www.linkedin.com/company/wearebravado/',
    icon: require('./images/linkedin.svg'),
  },
  twitter: {
    url: 'https://twitter.com/bravado_sales',
    icon: require('./images/twitter.svg'),
  },
  instagram: {
    url: 'https://www.instagram.com/bravado_sales/',
    icon: require('./images/instagram.svg'),
  },
};
